import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

function Home() {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            video.playbackRate = 0.5;
            video.play().catch(err => console.log('Autoplay prevented:', err));
        }
    }, []);

    const handleEnded = () => {
        if (videoRef.current) {
            videoRef.current.currentTime = 0;
            videoRef.current.play();
        }
    };

    return (
        <section className="home-section" id="home">
            <div className="home-overlay" />
            <div className="home-content">
                <div className="home-pill">Premium städning i Östergötland</div>
                <h1>Skapa en lugnare vardag med oss på Riktigt Rent</h1>
                <p>Trygga team, flexibla upplägg och tydliga avtal för både hem och företag.</p>
                <div className="home-cta-row">
                    <Link className="home-cta primary" to="/kontakt">Boka konsultation</Link>
                    <Link className="home-cta ghost" to="/services">Utforska tjänster</Link>
                </div>
                <div className="home-bullets" aria-label="Snabbfakta">
                    <span>RUT för privatpersoner</span>
                    <span>Företagsavtal & SLA</span>
                    <span>Miljövänliga metoder</span>
                </div>
            </div>
            <video
                className="home-video"
                autoPlay
                loop
                muted
                preload="metadata"
                ref={videoRef}
                onEnded={handleEnded}
                playsInline
            >
                <source src="/homevideo.webm" type="video/webm" />
                <source src="/homevideo.mp4" type="video/mp4" />
                Din webbläsare stödjer inte videouppspelning.
            </video>
        </section>
    );
}
export default Home;
